/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AddAbsenceRequest,
  AddDutyRosterShift,
  DepartmentDutyRosterGetParams,
  DepartmentDutyRosterResult,
  DutyShiftDto,
  EditDutyRosterShift,
  GetFormulaResultsParams,
  GetShiftParams,
  StringFormulaResultDictionaryWrapper
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType , BodyType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getDepartmentDutyRosterGetUrl = (params?: DepartmentDutyRosterGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["departmentTreeNodes"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/DepartmentDutyRoster/Get?${stringifiedParams}` : `/api/DepartmentDutyRoster/Get`
}

export const departmentDutyRosterGet = async (params?: DepartmentDutyRosterGetParams, options?: Parameters<typeof customInstance>[1]): Promise<DepartmentDutyRosterResult> => {

  return customInstance<DepartmentDutyRosterResult>(getDepartmentDutyRosterGetUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDepartmentDutyRosterGetQueryKey = (params?: DepartmentDutyRosterGetParams,) => {
    return [
    `/api/DepartmentDutyRoster/Get`, ...(params ? [params] : [])
    ] as const;
    }


export const getDepartmentDutyRosterGetQueryOptions = <TData = Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError = ErrorType<unknown>>(params?: DepartmentDutyRosterGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDepartmentDutyRosterGetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof departmentDutyRosterGet>>> = ({ signal }) => departmentDutyRosterGet(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DepartmentDutyRosterGetQueryResult = NonNullable<Awaited<ReturnType<typeof departmentDutyRosterGet>>>
export type DepartmentDutyRosterGetQueryError = ErrorType<unknown>


export function useDepartmentDutyRosterGet<TData = Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError = ErrorType<unknown>>(
 params: undefined |  DepartmentDutyRosterGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof departmentDutyRosterGet>>,
          TError,
          Awaited<ReturnType<typeof departmentDutyRosterGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDepartmentDutyRosterGet<TData = Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError = ErrorType<unknown>>(
 params?: DepartmentDutyRosterGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof departmentDutyRosterGet>>,
          TError,
          Awaited<ReturnType<typeof departmentDutyRosterGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDepartmentDutyRosterGet<TData = Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError = ErrorType<unknown>>(
 params?: DepartmentDutyRosterGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDepartmentDutyRosterGet<TData = Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError = ErrorType<unknown>>(
 params?: DepartmentDutyRosterGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDepartmentDutyRosterGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getDepartmentDutyRosterGetSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError = ErrorType<unknown>>(params?: DepartmentDutyRosterGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDepartmentDutyRosterGetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof departmentDutyRosterGet>>> = ({ signal }) => departmentDutyRosterGet(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type DepartmentDutyRosterGetSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof departmentDutyRosterGet>>>
export type DepartmentDutyRosterGetSuspenseQueryError = ErrorType<unknown>


export function useDepartmentDutyRosterGetSuspense<TData = Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError = ErrorType<unknown>>(
 params: undefined |  DepartmentDutyRosterGetParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDepartmentDutyRosterGetSuspense<TData = Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError = ErrorType<unknown>>(
 params?: DepartmentDutyRosterGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDepartmentDutyRosterGetSuspense<TData = Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError = ErrorType<unknown>>(
 params?: DepartmentDutyRosterGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDepartmentDutyRosterGetSuspense<TData = Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError = ErrorType<unknown>>(
 params?: DepartmentDutyRosterGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDepartmentDutyRosterGetSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getDepartmentDutyRosterAddAbsenceUrl = () => {




  return `/api/DepartmentDutyRoster/AddAbsence`
}

export const departmentDutyRosterAddAbsence = async (addAbsenceRequest?: AddAbsenceRequest, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getDepartmentDutyRosterAddAbsenceUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(addAbsenceRequest)
  }
);}





export const getDepartmentDutyRosterAddAbsenceMutationKey = () => ['departmentDutyRosterAddAbsence'] as const;

export const getDepartmentDutyRosterAddAbsenceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof departmentDutyRosterAddAbsence>>, TError,DepartmentDutyRosterAddAbsenceMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof departmentDutyRosterAddAbsence>>, TError,DepartmentDutyRosterAddAbsenceMutationVariables, TContext> => {

const mutationKey = getDepartmentDutyRosterAddAbsenceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof departmentDutyRosterAddAbsence>>, DepartmentDutyRosterAddAbsenceMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  departmentDutyRosterAddAbsence(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DepartmentDutyRosterAddAbsenceMutationResult = NonNullable<Awaited<ReturnType<typeof departmentDutyRosterAddAbsence>>>
    export type DepartmentDutyRosterAddAbsenceMutationBody = BodyType<AddAbsenceRequest> | undefined
    export type DepartmentDutyRosterAddAbsenceMutationError = ErrorType<unknown>
    export type DepartmentDutyRosterAddAbsenceMutationVariables = {data?: BodyType<AddAbsenceRequest>}

    export const useDepartmentDutyRosterAddAbsence = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof departmentDutyRosterAddAbsence>>, TError,DepartmentDutyRosterAddAbsenceMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof departmentDutyRosterAddAbsence>>,
        TError,
        DepartmentDutyRosterAddAbsenceMutationVariables,
        TContext
      > => {
      return useMutation(getDepartmentDutyRosterAddAbsenceMutationOptions(options), queryClient);
    }
    export const getDepartmentDutyRosterAddShiftUrl = () => {




  return `/api/DepartmentDutyRoster/AddShift`
}

export const departmentDutyRosterAddShift = async (addDutyRosterShift?: AddDutyRosterShift, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getDepartmentDutyRosterAddShiftUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(addDutyRosterShift)
  }
);}





export const getDepartmentDutyRosterAddShiftMutationKey = () => ['departmentDutyRosterAddShift'] as const;

export const getDepartmentDutyRosterAddShiftMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof departmentDutyRosterAddShift>>, TError,DepartmentDutyRosterAddShiftMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof departmentDutyRosterAddShift>>, TError,DepartmentDutyRosterAddShiftMutationVariables, TContext> => {

const mutationKey = getDepartmentDutyRosterAddShiftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof departmentDutyRosterAddShift>>, DepartmentDutyRosterAddShiftMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  departmentDutyRosterAddShift(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DepartmentDutyRosterAddShiftMutationResult = NonNullable<Awaited<ReturnType<typeof departmentDutyRosterAddShift>>>
    export type DepartmentDutyRosterAddShiftMutationBody = BodyType<AddDutyRosterShift> | undefined
    export type DepartmentDutyRosterAddShiftMutationError = ErrorType<unknown>
    export type DepartmentDutyRosterAddShiftMutationVariables = {data?: BodyType<AddDutyRosterShift>}

    export const useDepartmentDutyRosterAddShift = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof departmentDutyRosterAddShift>>, TError,DepartmentDutyRosterAddShiftMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof departmentDutyRosterAddShift>>,
        TError,
        DepartmentDutyRosterAddShiftMutationVariables,
        TContext
      > => {
      return useMutation(getDepartmentDutyRosterAddShiftMutationOptions(options), queryClient);
    }
    export const getDepartmentDutyRosterEditShiftUrl = () => {




  return `/api/DepartmentDutyRoster/EditShift`
}

export const departmentDutyRosterEditShift = async (editDutyRosterShift?: EditDutyRosterShift, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getDepartmentDutyRosterEditShiftUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(editDutyRosterShift)
  }
);}





export const getDepartmentDutyRosterEditShiftMutationKey = () => ['departmentDutyRosterEditShift'] as const;

export const getDepartmentDutyRosterEditShiftMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof departmentDutyRosterEditShift>>, TError,DepartmentDutyRosterEditShiftMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof departmentDutyRosterEditShift>>, TError,DepartmentDutyRosterEditShiftMutationVariables, TContext> => {

const mutationKey = getDepartmentDutyRosterEditShiftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof departmentDutyRosterEditShift>>, DepartmentDutyRosterEditShiftMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  departmentDutyRosterEditShift(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DepartmentDutyRosterEditShiftMutationResult = NonNullable<Awaited<ReturnType<typeof departmentDutyRosterEditShift>>>
    export type DepartmentDutyRosterEditShiftMutationBody = BodyType<EditDutyRosterShift> | undefined
    export type DepartmentDutyRosterEditShiftMutationError = ErrorType<unknown>
    export type DepartmentDutyRosterEditShiftMutationVariables = {data?: BodyType<EditDutyRosterShift>}

    export const useDepartmentDutyRosterEditShift = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof departmentDutyRosterEditShift>>, TError,DepartmentDutyRosterEditShiftMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof departmentDutyRosterEditShift>>,
        TError,
        DepartmentDutyRosterEditShiftMutationVariables,
        TContext
      > => {
      return useMutation(getDepartmentDutyRosterEditShiftMutationOptions(options), queryClient);
    }
    export const getGetShiftUrl = (params?: GetShiftParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/DepartmentDutyRoster/GetShift?${stringifiedParams}` : `/api/DepartmentDutyRoster/GetShift`
}

export const getShift = async (params?: GetShiftParams, options?: Parameters<typeof customInstance>[1]): Promise<DutyShiftDto> => {

  return customInstance<DutyShiftDto>(getGetShiftUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetShiftQueryKey = (params?: GetShiftParams,) => {
    return [
    `/api/DepartmentDutyRoster/GetShift`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetShiftQueryOptions = <TData = Awaited<ReturnType<typeof getShift>>, TError = ErrorType<unknown>>(params?: GetShiftParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getShift>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetShiftQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getShift>>> = ({ signal }) => getShift(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getShift>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetShiftQueryResult = NonNullable<Awaited<ReturnType<typeof getShift>>>
export type GetShiftQueryError = ErrorType<unknown>


export function useGetShift<TData = Awaited<ReturnType<typeof getShift>>, TError = ErrorType<unknown>>(
 params: undefined |  GetShiftParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getShift>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getShift>>,
          TError,
          Awaited<ReturnType<typeof getShift>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetShift<TData = Awaited<ReturnType<typeof getShift>>, TError = ErrorType<unknown>>(
 params?: GetShiftParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getShift>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getShift>>,
          TError,
          Awaited<ReturnType<typeof getShift>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetShift<TData = Awaited<ReturnType<typeof getShift>>, TError = ErrorType<unknown>>(
 params?: GetShiftParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getShift>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetShift<TData = Awaited<ReturnType<typeof getShift>>, TError = ErrorType<unknown>>(
 params?: GetShiftParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getShift>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetShiftQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetShiftSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getShift>>, TError = ErrorType<unknown>>(params?: GetShiftParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getShift>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetShiftQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getShift>>> = ({ signal }) => getShift(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getShift>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetShiftSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getShift>>>
export type GetShiftSuspenseQueryError = ErrorType<unknown>


export function useGetShiftSuspense<TData = Awaited<ReturnType<typeof getShift>>, TError = ErrorType<unknown>>(
 params: undefined |  GetShiftParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getShift>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetShiftSuspense<TData = Awaited<ReturnType<typeof getShift>>, TError = ErrorType<unknown>>(
 params?: GetShiftParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getShift>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetShiftSuspense<TData = Awaited<ReturnType<typeof getShift>>, TError = ErrorType<unknown>>(
 params?: GetShiftParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getShift>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetShiftSuspense<TData = Awaited<ReturnType<typeof getShift>>, TError = ErrorType<unknown>>(
 params?: GetShiftParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getShift>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetShiftSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetFormulaResultsUrl = (params?: GetFormulaResultsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["contractIds","formulaIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/DepartmentDutyRoster/GetFormulaResults?${stringifiedParams}` : `/api/DepartmentDutyRoster/GetFormulaResults`
}

export const getFormulaResults = async (params?: GetFormulaResultsParams, options?: Parameters<typeof customInstance>[1]): Promise<StringFormulaResultDictionaryWrapper> => {

  return customInstance<StringFormulaResultDictionaryWrapper>(getGetFormulaResultsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetFormulaResultsQueryKey = (params?: GetFormulaResultsParams,) => {
    return [
    `/api/DepartmentDutyRoster/GetFormulaResults`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetFormulaResultsQueryOptions = <TData = Awaited<ReturnType<typeof getFormulaResults>>, TError = ErrorType<unknown>>(params?: GetFormulaResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFormulaResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFormulaResultsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFormulaResults>>> = ({ signal }) => getFormulaResults(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFormulaResults>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFormulaResultsQueryResult = NonNullable<Awaited<ReturnType<typeof getFormulaResults>>>
export type GetFormulaResultsQueryError = ErrorType<unknown>


export function useGetFormulaResults<TData = Awaited<ReturnType<typeof getFormulaResults>>, TError = ErrorType<unknown>>(
 params: undefined |  GetFormulaResultsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFormulaResults>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFormulaResults>>,
          TError,
          Awaited<ReturnType<typeof getFormulaResults>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFormulaResults<TData = Awaited<ReturnType<typeof getFormulaResults>>, TError = ErrorType<unknown>>(
 params?: GetFormulaResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFormulaResults>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFormulaResults>>,
          TError,
          Awaited<ReturnType<typeof getFormulaResults>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFormulaResults<TData = Awaited<ReturnType<typeof getFormulaResults>>, TError = ErrorType<unknown>>(
 params?: GetFormulaResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFormulaResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetFormulaResults<TData = Awaited<ReturnType<typeof getFormulaResults>>, TError = ErrorType<unknown>>(
 params?: GetFormulaResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFormulaResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFormulaResultsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetFormulaResultsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getFormulaResults>>, TError = ErrorType<unknown>>(params?: GetFormulaResultsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFormulaResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFormulaResultsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFormulaResults>>> = ({ signal }) => getFormulaResults(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFormulaResults>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetFormulaResultsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getFormulaResults>>>
export type GetFormulaResultsSuspenseQueryError = ErrorType<unknown>


export function useGetFormulaResultsSuspense<TData = Awaited<ReturnType<typeof getFormulaResults>>, TError = ErrorType<unknown>>(
 params: undefined |  GetFormulaResultsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFormulaResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFormulaResultsSuspense<TData = Awaited<ReturnType<typeof getFormulaResults>>, TError = ErrorType<unknown>>(
 params?: GetFormulaResultsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFormulaResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFormulaResultsSuspense<TData = Awaited<ReturnType<typeof getFormulaResults>>, TError = ErrorType<unknown>>(
 params?: GetFormulaResultsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFormulaResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetFormulaResultsSuspense<TData = Awaited<ReturnType<typeof getFormulaResults>>, TError = ErrorType<unknown>>(
 params?: GetFormulaResultsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFormulaResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFormulaResultsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






